export default "__VITE_ASSET__CRxJP35l__"